import { render, staticRenderFns } from "./TextPolicyData.vue?vue&type=template&id=16444b9c&scoped=true&"
import script from "./TextPolicyData.vue?vue&type=script&lang=js&"
export * from "./TextPolicyData.vue?vue&type=script&lang=js&"
import style0 from "./TextPolicyData.vue?vue&type=style&index=0&id=16444b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16444b9c",
  null
  
)

export default component.exports